module.exports = __webpack_public_path__ + "static/media/promote-green.ff0268c0.svg";